<template>
  <div class="opacity" v-if="showPoster">
    <div class="poster" id="myposter">
      <div class="top">
        <img
          class="logo"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/94767178732c62a25c1db4d52e24a156.png"
          alt=""
        />
        <TopContent style="padding-top: 46px" />
      </div>
      <div class="bottom">
        <div class="b-list">
          <div class="b-item" v-if="[0, 1, 2].includes(posterType)">
            <div class="title-1">
              <div class="t-line">
                <div class="line"></div>
                <div class="circle"></div>
              </div>
              <div class="t-title">7日营养菜谱</div>
              <div class="t-line t-line-after">
                <div class="line"></div>
                <div class="circle"></div>
              </div>
            </div>
            <div class="recipe-list" v-if="menuData">
              <div class="recipe-item" v-if="[0, 1].includes(posterType)">
                <div class="title-2">自制版菜谱</div>
                <FoodTableMake :data="makeData" />
              </div>
              <div class="recipe-item" v-if="[0, 2].includes(posterType)">
                <div class="title-2">外卖版菜谱</div>
                <FoodTableTakeaway :data="takeawayData" />
              </div>
            </div>
          </div>
          <!-- 饮食建议 -->
          <div class="b-item" v-if="[0, 3].includes(posterType)">
            <div class="title-1">
              <div class="t-line">
                <div class="line"></div>
                <div class="circle"></div>
              </div>
              <div class="t-title">饮食建议</div>
              <div class="t-line t-line-after">
                <div class="line"></div>
                <div class="circle"></div>
              </div>
            </div>
            <div class="a-content" v-if="advice.length">
              <div class="a-item" v-for="(item, index) in advice" :key="index">
                <div class="a-title"
                  >{{ item.title
                  }}<span
                    class="iconfont icon-warning-fill"
                    v-if="item.danger"
                  ></span
                ></div>
                <div class="a-list">
                  <div
                    class="i-item"
                    v-for="(item1, index1) in item.list"
                    :key="index1"
                  >
                    <div class="i-title"
                      >{{ index1 + 1 }}、{{ item1.title }}</div
                    >
                    <div class="i-text" v-html="item1.content"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="b-item" v-if="[0, 4].includes(posterType)">
            <div class="title-1">
              <div class="t-line">
                <div class="line"></div>
                <div class="circle"></div>
              </div>
              <div class="t-title">每日小目标</div>
              <div class="t-line t-line-after">
                <div class="line"></div>
                <div class="circle"></div>
              </div>
            </div>
            <div class="goal-list">
              <div class="item" v-for="(item, index) in goalList" :key="index">
                <div class="item-dot"></div>
                <img class="item-icon" :src="item.icon_url" alt="" />
                <div class="item-title"
                  ><span class="item-num">{{ index + 1 }}</span
                  >{{ item.title }}</div
                >
                <div class="item-text" v-html="item.content"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="f-left">
            <div class="text"
              >扫码下载betterWE APP 了解更多<span
                class="iconfont icon-you"
              ></span
              ><span class="icon-r iconfont icon-you"></span>
            </div>
            <img
              class="logo"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-logo"
              alt=""
            />
          </div>
          <img
            class="qrcode"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e5c64fd9b51098b5be5065266e807c92.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import html2canvas from 'html2canvas'
import TopContent from './top-content.vue'
import FoodTableMake from './food-table-make.vue'
import FoodTableTakeaway from './food-table-takeaway.vue'
export default {
  components: {
    TopContent,
    FoodTableMake,
    FoodTableTakeaway
  },
  props: {
    posterType: {
      type: Number,
      default: 0 //0：全部 1：自制 2：外卖 3：饮食建议 4：每日小目标
    },
    id: {
      type: Number,
      default: 0
    }
    /*  advice:{
             type: Array,
             default: ()=>[], 
         },
         goal:{
             type: Array,
             default: ()=>[], 
         }, */
  },
  inject: {
    bindShowToast: { value: 'bindShowToast', default: null }
  },
  data() {
    return {
      showPoster: false,
      imageUrl: '',
      totalImage: 0,
      curImage: 0,
      posterLoaded: false
    }
  },
  computed: {
    advice() {
      let info = this.$store.state.cnaV2.resultData
      if (info) {
        let data = info.adviceList.advice
        let advice = []
        advice.push({
          title: '日常饮食',
          danger: false,
          list: data.dietList
        })
        advice.push({
          title: '补充维生素/矿物质',
          danger: false,
          list: data.vitaminList
        })
        advice.push({
          title: '减少摄入',
          danger: true,
          list: data.ingestionList
        })
        return advice
      }
      return []
    },
    goalList() {
      let info = this.$store.state.cnaV2.resultData
      if (info) {
        let data = info.adviceList.daily_tip
        return data
      }
      return []
    },
    menuData() {
      let info = this.$store.state.cnaV2.menuData
      return info || null
    },
    takeawayData() {
      return this.$store.state.cnaV2.menuData[1].data
    },
    makeData() {
      return this.$store.state.cnaV2.menuData[0].data
    }
  },
  created() {},
  methods: {
    ...mapActions('cnaV2', ['getMenuData']),
    getData() {
      if ([0, 1, 2].includes(this.posterType)) {
        if (this.menuData) {
          this.loadPoster()
        } else {
          this.getRecipe()
        }
      } else {
        this.loadPoster()
      }
    },
    loadPoster() {
      this.showPoster = true
      this.$nextTick(() => {
        this.addEventToAllImage()
        this.$toast.loading('正在加载资源...')
      })
    },
    getRecipe() {
      this.getMenuData()
        .then((res) => {
          if (res.code == 200) {
            this.loadPoster()
          } else if (res.code == 421) {
            this.bindShowToast && this.bindShowToast()
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    //添加所有监听事件
    addEventToAllImage() {
      if (this.posterLoaded) {
        this.bindAllImagesLoaded()
      } else {
        let parent = document.getElementById('myposter')
        this.totalImage = 0
        this.curImage = 0
        this.addOnloadEvent(parent)
      }
      /* 如果超过6秒还是没有加载完成图片时默认 */
      setTimeout(() => {
        if (!this.posterLoaded) {
          this.$toast.clear()
          this.$toast('图片加载超时,海报生成中断')
        }
      }, 6000)
    },
    addOnloadEvent(el) {
      if (el.nodeName == 'IMG') {
        this.totalImage++
        el.addEventListener('load', () => {
          this.bindImageLoaded()
        })
      }
      let children = Array.from(el.children)
      if (children.length) {
        children.map((item) => {
          this.addOnloadEvent(item)
        })
      }
    },
    bindImageLoaded() {
      this.curImage++
      if (this.curImage >= this.totalImage) {
        console.log('图片加载完成')
        this.posterLoaded = true
        this.bindAllImagesLoaded()
      }
    },
    bindAllImagesLoaded() {
      this.$toast.clear()
      // window.scrollTo(0, 0); //html2canvas插件问题必须滚动到顶部才能正常生成
      setTimeout(() => {
        this.createPoster()
      }, 100)
    },
    start() {
      this.getData()
    },
    createPoster() {
      this.$toast.loading('图片生成中...')
      html2canvas(document.getElementById('myposter'), {
        backgroundColor: null,
        useCORS: true
      })
        .then((canvas) => {
          this.$toast.clear()
          this.imageUrl = canvas.toDataURL()
          if (this.$betterwe.isApp()) {
            let params = {
              data: this.imageUrl,
              type: 'base64'
            }
            this.$betterwe.onAppSaveImage(params)
          } else {
            this.downdloadPoster(this.imageUrl)
          }
        })
        .catch((err) => {
          console.log(err)
          this.$toast.clear()
          this.$toast('生成图片失败')
        })
        .finally(() => {})
    },
    //h5下载海报
    downdloadPoster(image) {
      const a = document.createElement('a')
      const filename = '海报.png'
      a.href = image // picSrc  是图片 base64 码，可以直接给 img 的 src 属性，展示图片
      a.download = filename
      document.body.appendChild(a)
      a.click()
      setTimeout(() => {
        document.body.removeChild(a)
      }, 1000)
    }
  }
}
</script>
<style lang="scss" scoped>
.opacity {
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  opacity: 0;
  z-index: -1;
}

.poster {
  overflow: hidden;
  background: #75ddc4;

  .top {
    padding-bottom: -8px;
    position: relative;

    .logo {
      position: absolute;
      left: 50%;
      top: 30px;
      z-index: 1;
      transform: translate(-50%, 0%);
      height: 14px;
    }
  }

  .bottom {
    background: #ffffff;
    border-radius: 16px 16px 0px 0px;
    padding: 28px 20px 20px;

    .b-list {
      .b-item {
        margin-bottom: 50px;

        .recipe-list {
          .recipe-item {
            margin-bottom: 40px;
          }

          .recipe-item:last-child {
            margin-bottom: 0px;
          }
        }
      }

      .b-item:last-child {
        margin-bottom: 0px;
      }
    }

    .title-1 {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 28px;

      .t-title {
        margin: 0 15px;
        font-size: 24px;
        font-family: Alibaba-PuHuiTi-B, Alibaba-PuHuiTi;
        font-weight: 600;
        color: #000000;
        line-height: 26px;
      }

      .t-line {
        display: flex;
        align-items: center;

        .circle {
          width: 6px;
          height: 6px;
          background: #66ccba;
          transform: rotate(45deg);
        }

        .line {
          width: 55px;
          height: 1px;
          background: linear-gradient(
            90deg,
            rgba(102, 204, 186, 0),
            rgba(102, 204, 186, 1)
          );
        }
      }

      .t-line-after {
        transform: rotate(180deg);
      }
    }

    .title-2 {
      margin: 0 auto 16px;
      text-align: center;
      width: 276px;
      height: 35px;
      background: linear-gradient(
        270deg,
        rgba(235, 250, 248, 0) 0%,
        #dffffb 49%,
        rgba(210, 243, 239, 0) 100%
      );
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 35px;
    }

    .a-content {
      padding: 20px 16px;
      background: rgba(244, 246, 250, 0.9);
      border-radius: 12px;

      .a-item {
        margin-bottom: 30px;

        .a-title {
          position: relative;
          padding-left: 10px;
          box-sizing: border-box;
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 21px;
          margin-bottom: 20px;
          display: flex;
          align-items: center;

          .iconfont {
            color: rgb(253, 97, 129);
            font-size: 22px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .a-title::after {
          content: '';
          position: absolute;
          width: 4px;
          height: 17px;
          background: #66ccba;
          left: 0;
          top: 50%;
          transform: translate(0%, -50%);
        }

        .a-list {
          .i-item {
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            line-height: 20px;
            margin-bottom: 16px;

            .i-title {
              font-size: 14px;
              color: rgba(0, 0, 0, 0.8);
              font-weight: 600;
            }

            .i-text {
              color: rgba(0, 0, 0, 0.5);
            }
          }

          .i-item:last-child {
            margin-bottom: 0;
          }
        }
      }

      .a-item:last-child {
        margin-bottom: 0;
      }
    }

    .goal-list {
      .item {
        position: relative;
        padding: 16px;
        background: rgba(233, 246, 252, 0.88);
        border-radius: 12px;
        margin-bottom: 20px;

        .item-dot {
          position: absolute;
          right: 20px;
          top: 8px;
          width: 31px;
          height: 31px;
          border-radius: 50%;
          overflow: hidden;
          background: #b1e5fc;
        }

        .item-icon {
          position: absolute;
          right: 16px;
          top: -12px;
          width: 49px;
          height: 49px;
          object-fit: contain;
        }

        .item-title {
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #000000;
          line-height: 21px;
          margin-bottom: 16px;

          .item-num {
            font-size: 20px;
            margin-right: 6px;
          }
        }

        .item-text {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 20px;
        }
      }

      .item:nth-child(2) {
        background-color: rgba(234, 246, 243, 0.88);

        .item-dot {
          background: #b5e4d2;
        }
      }

      .item:nth-child(3) {
        background-color: rgba(241, 239, 251, 0.88);

        .item-dot {
          background: #d1c5fe;
        }
      }

      .item:last-child {
        margin-bottom: 0;
      }
    }

    .footer {
      margin-top: 33px;
      display: flex;
      align-items: center;

      .f-left {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;

        .text {
          font-size: 12px;
          font-family: MiSans-Demibold, MiSans;
          font-weight: 600;
          color: #201832;
          line-height: 16px;
          margin-bottom: 6px;

          .icon-r {
            color: rgba(32, 24, 50, 0.5);
            margin-left: -10px;
          }
        }

        .logo {
          height: 12px;
        }
      }

      .qrcode {
        width: 61px;
        height: 61px;
        object-fit: contain;
      }
    }
  }
}
</style>
